import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { dashboardAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import WaitScreen from "../LodingScreen/WaitScreen";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import SectionLoader from "../LodingScreen/SectionLoader";

function Testimonials() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const [testimonials, setTestimonials] = useState<any[]>([]);
  const testimonialData: any = useSelector((state: any) => state.dashboard.testimonial ? state.dashboard.testimonial : {});

  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(dashboardAction.getTestimonialAction(/* {segment:location?.state?.type ? location?.state?.type : ""} */{}));
    return () => { }
  }, [/* location?.state?.type */]);

  useEffect(() => {
    if (testimonialData && Array.isArray(testimonialData) && testimonialData?.length > 0) {
      window?.scrollTo(0, 0);
      if (location?.state?.type) {
        let tData: any[] = testimonialData.filter((ele: any) => ele.Segment === location?.state?.type);
        setTestimonials(tData);
      } else {
        setTestimonials(testimonialData);
      }
    }
    return () => { }
  }, [location?.state?.type, testimonialData]);

  return (
    <>
      <SeoAdd slug={ROUTE.TEAM} />
      <BreadCrumb page={t("testimonials")} data={{ slug: "", path: "#" }} />
      <section className="team-section">
        <div className="container">
          <div className="text-center"><img className="scale" src={t("images.testimonial_banner")} alt="" /></div>
          <div className="tab-content">
            <div className="mt-25 text-center">
              <h2>{t("testimonials")}</h2>
              <div className="mt-25">
                <p className="text-center dull_heading pb-3">
                  {t("testimonial_content")}
                </p>
              </div>
            </div>
            {testimonialData && Object.keys(testimonialData).length > 0 ?
              <>
                {testimonials &&
                  <div className="equal_clm h-services testimonial_list">
                    {testimonials && testimonials?.length > 0 ? testimonials?.map((item: any, i: any) => (
                      <div className="infobox_wrapper doctor_card h421" key={i}>
                        <div >
                          <div >
                            <div className="team_member">
                              <figure className="effect-julia">
                                <img src={item?.ProfileImage ? item?.ProfileImage : item?.Gender && item?.Gender?.toLowerCase() == "female" ? "/assets/img/testi_female.png" : "/assets/img/testi_male.png"} onError={(e: any) => ImgPlaceHolder(e, item?.Gender && item?.Gender?.toLowerCase() == "female" ? "/assets/img/testi_female.png" : "/assets/img/testi_male.png")} alt="" />
                              </figure>
                              <div className="member_name">
                                {item?.VideoUrl && item?.VideoUrl != '' ?
                                  <p>
                                    <ReactPlayer className="testimonialVdo" controls url={item?.VideoUrl} />
                                  </p> : <p dangerouslySetInnerHTML={{ __html: item?.Content && item?.Content }}></p>
                                }
                                <h5><span></span>{item?.Name}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )) :
                      (<div className="singl_clm testimonial_list">
                        <div className="infobox_wrapper doctor_card text-center f-16">
                          {t("no_data_available")}
                        </div>
                      </div>)
                    }
                  </div>}
              </>
              :
              <SectionLoader />
            }
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
